import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('bldn-configuration')
export class BldnConfiguration extends LitElement {
  render() {
    return html``;
  }
}
